import {Component, signal, OnInit} from '@angular/core';
import {JsonPipe} from '@angular/common';

@Component({
  selector: 'app-gtm-debug-panel',
  standalone: true,
  template: `
    <div class="gtm-debug">
      <h3>GTM Debug Panel</h3>
      <pre>{{ dataLayer() | json }}</pre>
    </div>
  `,
  imports: [
    JsonPipe
  ],
  styles: [`
    .gtm-debug {
      position: fixed;
      bottom: 0;
      right: 0;
      width: 400px;
      max-height: 300px;
      overflow: auto;
      font-size: 12px;
      background: rgba(0, 0, 0, 0.85);
      color: #0f0;
      padding: 8px;
      border-top-left-radius: 8px;
      z-index: 9999;
    }

    h3 {
      margin: 0 0 4px 0;
      font-size: 14px;
    }
  `]
})
export class GtmDebugPanelComponent implements OnInit {
  dataLayer = signal<any[]>([]);

  ngOnInit(): void {
    const w = window as any;
    w.dataLayer = w.dataLayer || [];

    this.dataLayer.set([...w.dataLayer]);

    const origPush = w.dataLayer.push;
    w.dataLayer.push = (...args: any[]) => {
      const result = origPush.apply(w.dataLayer, args);
      this.dataLayer.set([...w.dataLayer]);
      return result;
    };
  }
}
